import Button from 'components/Forms/Button/Button';
import useTranslation from 'next-translate/useTranslation';
import { MenuBasketIcon, SpinnerIcon } from 'public/svg/IconsSvg';
import twMerge from 'utils/twMerge';

type AddToCartButtonPrimaryProps = {
    onClick: () => void;
    isLoading?: boolean;
    testIdentifier?: string;
    isBookingOnly: boolean;
    className?: string;
    isResponsive?: boolean;
    isDisabled?: boolean;
};

export const AddToCartButtonPrimary: FC<AddToCartButtonPrimaryProps> = ({
    onClick,
    testIdentifier,
    isBookingOnly,
    isLoading,
    className,
    isResponsive = true,
    isDisabled = false,
}) => {
    const { t } = useTranslation();

    return (
        <Button
            isDisabled={isDisabled}
            className={twMerge(
                'h-12 justify-center rounded-md py-0 px-5 text-h5 vl:h-14 vl:px-6',
                isResponsive && 'w-full vl:w-auto',
                className,
            )}
            onClick={onClick}
            type="button"
            variant="primary"
            data-testid={testIdentifier}
        >
            {isLoading ? (
                <SpinnerIcon className="h-[26px] w-[26px]" />
            ) : (
                <MenuBasketIcon className="h-6 w-6 stroke-white" />
            )}
            {isResponsive && <span className="vl:hidden">{isBookingOnly ? t('Book') : t('Add to cart')}</span>}
            <span className={twMerge(isResponsive && 'hidden vl:inline')}>
                {isBookingOnly ? t('Book') : t('Add to cart (long)')}
            </span>
        </Button>
    );
};
